import classNames from 'classnames';
import fetch from 'isomorphic-fetch';
import React, { Component } from 'react';

import { SHARE_VIDEO } from 'constants/checklist';
import {
  SHARE_MENU_ACTION_FB_SHARE,
  SHARE_MENU_ACTION_GM_SHARE,
  SHARE_MENU_ACTION_LINK,
  SHARE_MENU_ACTION_TW_SHARE,
} from 'constants/events';
import * as sentry from 'utilities/sentry';
import { getAnimatedPreview } from 'utilities/video';

import { useCompleteChecklistItem } from 'hooks/checklist';

import CopyLinkDropdownItem from '../copy-link-dropdown-item';
import EmbedCodeDropdownItem from '../embed-code-dropdown-item';
import EmbedThumbnailDropdownItem from '../embed-thumbnail-dropdown-item';
import FacebookDropdownItem from '../facebook-dropdown-item';
import GmailDropdownItem from '../gmail-dropdown-item';
import TwitterDropdownItem from '../twitter-dropdown-item';
import { trackFromVideo } from '../utils';

import DropdownMenu from 'components/dropdown-menu';

import './styles.less';

const ShareDropdownMenuWrapper = props => {
  const { completeChecklistItem } = useCompleteChecklistItem(SHARE_VIDEO);

  return (
    <ShareDropdownMenu
      completeChecklistItem={completeChecklistItem}
      {...props}
    />
  );
};

class ShareDropdownMenu extends Component {
  static defaultProps = {
    show: false,
    onHide: () => {},
    align: 'left',
    vAlign: 'auto',
  };

  render() {
    const {
      additionalClass,
      currentUserIsOwner,
      hasGmailAccount,
      showFacebook = true,
      video,
      show: dropdownOpen,
      align,
      vAlign,
      handleEmbedCodeClick = null,
      handleEmbedThumbClick = null,
      completeChecklistItem,
    } = this.props;

    const showLinkedGif = Boolean(getAnimatedPreview(video));

    return (
      <DropdownMenu
        show={dropdownOpen}
        align={align}
        vAlign={vAlign}
        additionalClass={classNames(additionalClass)}
      >
        <CopyLinkDropdownItem
          onClick={this.handleCopyLinkClick(video)}
          video={video}
          completeChecklistItem={completeChecklistItem}
        />
        {showLinkedGif && handleEmbedThumbClick && (
          <EmbedThumbnailDropdownItem
            onClick={e => {
              handleEmbedThumbClick(e);
              completeChecklistItem();
            }}
          />
        )}
        {handleEmbedCodeClick && (
          <EmbedCodeDropdownItem
            onClick={e => {
              handleEmbedCodeClick(e);
              completeChecklistItem();
            }}
          />
        )}
        <div className="embed" />
        <TwitterDropdownItem
          currentUserIsOwner={currentUserIsOwner}
          onClick={this.trackTwitterClick(video)}
          video={video}
        />
        {showFacebook && window.fbReady && (
          <FacebookDropdownItem
            currentUserIsOwner={currentUserIsOwner}
            onClick={this.trackFacebookClick(video)}
            video={video}
          />
        )}
        {hasGmailAccount && (
          <GmailDropdownItem
            onClick={this.trackGmailClick(video)}
            video={video}
          />
        )}
      </DropdownMenu>
    );
  }

  handleCopyLinkClick = video => event => {
    event.stopPropagation();

    trackFromVideo(video, SHARE_MENU_ACTION_LINK);

    this.props.onHide();
  };

  trackFacebookClick = video => () => {
    this.props.completeChecklistItem();

    this.postIfLogged('/api/users/shared-video-on-fb');
    trackFromVideo(video, SHARE_MENU_ACTION_FB_SHARE);
  };

  trackTwitterClick = video => () => {
    this.props.completeChecklistItem();

    this.postIfLogged('/api/users/tweeted-video');
    trackFromVideo(video, SHARE_MENU_ACTION_TW_SHARE);
  };

  trackGmailClick = video => () => {
    this.props.completeChecklistItem();

    trackFromVideo(video, SHARE_MENU_ACTION_GM_SHARE);
  };

  postIfLogged = url => {
    const { isLoggedIn } = this.props;

    if (!isLoggedIn) {
      return;
    }

    fetch(url, {
      method: 'POST',
      credentials: 'include',
    }).catch(err => {
      sentry.logException(err, `error POST ${url}`);
    });
  };
}

export default ShareDropdownMenuWrapper;
